module.exports = __webpack_public_path__ + "img/DE03494.b079a779.png";